import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('views/home/index.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('views/news/list.vue')
  },
  {
    path: '/news/:id',
    name: 'article',
    component: () => import('views/news/open.vue')
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: () => import('views/gallery/list.vue')
  },
  {
    path: '/gallery/:id',
    name: 'photos',
    component: () => import('views/gallery/open.vue')
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('views/documents/list.vue')
  },
  {
    path: '/documents/:id',
    name: 'documentsOpen',
    component: () => import('views/documents/open.vue')
  },
  {
    path: '/documents/:cat_id/:id',
    name: 'documentsShow',
    component: () => import('views/documents/show.vue')
  },
  {
    path: '/institutions',
    name: 'institutions',
    component: () => import('views/institutions/index.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('views/contacts/index.vue')
  },
  {
    path: '/management',
    name: 'management',
    component: () => import('views/management/index.vue')
  },
  {
    path: '/partitions',
    name: 'partitions',
    component: () => import('views/partitions/list.vue')
  },
  {
    path: '/partitions/:id',
    name: 'partition',
    component: () => import('views/partitions/open.vue')
  },
  {
    path: '/material/:id',
    name: 'partitionsShow',
    component: () => import('views/partitions/show.vue')
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('views/apply/index.vue')
  },
  {
    path: '*',
    name: 'notfound',
    component: () => import('views/PageNotFound.vue')
  }
]

routes.forEach((item) => {
  const { meta } = item
  let { path } = item
  let baseDir = '/'
  if (meta && meta.project) {
    baseDir = `/${meta.project}`
  }

  if (path === '/home') {
    path = `${baseDir}/`
  } else if (path === '/' && item.redirect) {
    item.redirect = `${baseDir}/`
  } else {
    path = `${path}`
  }

  item.path = path
})

export default function createRouter () {
  return new Router({
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
      if (to.hash !== '') {
        return { selector: to.hash }
      } else {
        return { x: 0, y: 0 }
      }
    },
    fallback: true,
    routes
  })
}
